import PropTypes from "prop-types";
import {
	StyledSelectableUpperUnit,
	StyledSelectableUpperUnitWrapper,
} from "../../../styles/StyledSelectableUpperUnits/StyledSelectableUpperUnit";

const SelectableRadioUnit = ({ data, value, selectedUnit }) => {
	const { name } = data;

	return (
		<StyledSelectableUpperUnit checked={selectedUnit === value}>
			<StyledSelectableUpperUnitWrapper>
				<p>{name}</p>
			</StyledSelectableUpperUnitWrapper>
			<input type="radio" name="decisionMember" value={value} defaultChecked={selectedUnit === value} />
			<span className="checkmark"></span>
		</StyledSelectableUpperUnit>
	);
};

export default SelectableRadioUnit;

SelectableRadioUnit.propTypes = {
	value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	selectedUnit: PropTypes.string,
	data: PropTypes.object,
};
